import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import "./hackerResources.css";

const HackerResources = () => {
  const { authState } = useAuth();
  const account = authState.isAuthenticated ? authState.user?.email : null;
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  // Do not show a previous account's links while the next account is loading.
  const current = result?.account === account ? result : null;

  useEffect(() => {
    setResult(null);
    if (!account) return;
    let active = true;
    axiosInstance.get("/api/hacker-resources").then(({ data }) => {
      if (active) setResult({ account, resources: data.resources });
    }).catch((error) => {
      if (!active) return;
      const denied = [401, 403, 404].includes(error.response?.status);
      setResult({
        account,
        denied,
        error: denied
          ? "Resources are available only to hackers with confirmed attendance for the current event."
          : "We could not load your resources. Please try again.",
      });
    });
    return () => { active = false; };
  }, [account, retry]);

  return (
    <section className="hacker-resources" aria-labelledby="hacker-resources-heading"
      aria-busy={Boolean(account && !current)}>
      <header className="hacker-resources-header">
        <span className="hacker-resources-label">HackPrinceton / Fall 2026</span>
        <h3 id="hacker-resources-heading">Hacker resources</h3>
        <p>Your event links and information, all in one place.</p>
      </header>
      {!account ? (
        <p role="alert">Sign in to view your hacker resources.</p>
      ) : !current ? (
        <p role="status">Loading your resources...</p>
      ) : current.error ? (
        <div className="hacker-resources-error">
          <p role="alert">{current.error}</p>
          {!current.denied && <button type="button" onClick={() => setRetry(value => value + 1)}>Try again</button>}
        </div>
      ) : (
        <>
          <div className="hacker-resources-grid">
            {current.resources.map((resource, index) => (
              <a key={resource.id} className="hacker-resource-card" href={resource.url}
                target="_blank" rel="noopener noreferrer">
                <span className="hacker-resource-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                <h4>{resource.title}</h4>
                <p>{resource.description}</p>
                <span className="hacker-resource-action">{resource.action} <span aria-hidden="true">↗</span></span>
                <span className="hacker-resource-new-tab">Opens in a new tab</span>
              </a>
            ))}
          </div>
          <div className="hacker-resources-note">
            <strong>Before you arrive</strong>
            <p>Bring your student ID for check-in. If it is lost, arrange a replacement before the event.</p>
          </div>
          <footer className="hacker-resources-footer">
            <p>Check back here for additional resources and event updates.</p>
          </footer>
        </>
      )}
    </section>
  );
};

export default HackerResources;
